const baseClass = 'animate-spin rounded-full border-gray-300';

const borderTop = {
    primary: 'border-t-primary',
    secondary: 'border-t-secondary',
    danger: 'border-t-danger',
    success: 'border-t-success',
    warning: 'border-t-warning',
    info: 'border-t-info',
    neutral: 'border-t-neutral',
};

const sizeClasses = {
    xs: 'w-3 h-3 border',
    sm: 'w-4 h-4 border-2',
    md: 'w-5 h-5 border-4',
    lg: 'w-6 h-6 border-4',
};

function Loading({ variant = 'primary', size = 'sm', className }) {
    return (
        <div
            className={`${baseClass} ${sizeClasses[size]} ${borderTop[variant]} ${className}`}
        ></div>
    );
}

export default Loading;
